import { render, staticRenderFns } from "./FamilyBulkUpload.vue?vue&type=template&id=16c33c04&scoped=true"
import script from "./FamilyBulkUpload.vue?vue&type=script&lang=js"
export * from "./FamilyBulkUpload.vue?vue&type=script&lang=js"
import style0 from "./FamilyBulkUpload.vue?vue&type=style&index=0&id=16c33c04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c33c04",
  null
  
)

export default component.exports